import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  class: "section-share-containner"
};
var _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "section-share-header"
}, "分享到", -1);
var _hoisted_3 = {
  class: "section-share-list"
};
var _hoisted_4 = ["onClick"];
var _hoisted_5 = ["src"];
var _hoisted_6 = {
  class: "section-share-item-label"
};
var _hoisted_7 = {
  class: "section-share-footer"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_van_popup = _resolveComponent("van-popup");
  return _openBlock(), _createBlock(_component_van_popup, {
    show: $data.visible,
    "onUpdate:show": _cache[1] || (_cache[1] = function ($event) {
      return $data.visible = $event;
    }),
    position: "bottom",
    "safe-area-inset-bottom": "",
    class: "c-popup-appshare"
  }, {
    default: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.apiList, function (item) {
        return _openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["section-share-item", item.name === 'CopyUrl' ? 'btn-copy-link' : '']),
          key: item.id,
          onClick: function onClick($event) {
            return $options.openAppShare(item);
          }
        }, [_createElementVNode("img", {
          class: "section-share-item-icon",
          src: item.icon
        }, null, 8, _hoisted_5), _createElementVNode("div", _hoisted_6, _toDisplayString(item.label), 1)], 10, _hoisted_4);
      }), 128))])]), _createElementVNode("div", _hoisted_7, [_createElementVNode("button", {
        type: "button",
        class: "btn-cancel",
        onClick: _cache[0] || (_cache[0] = function () {
          return $options.handleCancel && $options.handleCancel.apply($options, arguments);
        })
      }, "取消")])];
    }),
    _: 1
  }, 8, ["show"]);
}